module.exports = __webpack_public_path__ + "img/arrow.bcd81c2e.svg";